import {connect} from 'react-redux';

import type {GlobalState} from 'types/store';
import type {Channel} from '@mattermost/types/channels';

import {getReadOnlyStateByChannelId} from '../../selectors/get_read_only_state_by_channel_id';

import {HideWhenChannelIsReadOnly} from './with_read_only_channel';

type OwnProps = {
    channelId: Channel['id'];
}

function mapStateToProps(state: GlobalState, ownProps: OwnProps) {
    return {
        isReadOnly: getReadOnlyStateByChannelId(state, ownProps.channelId),
    };
}

export default connect(mapStateToProps)(HideWhenChannelIsReadOnly);
